import { AnyAction } from 'redux';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { AssessmentPagePayload } from 'types/assessment-payload';
import { abortPageController, getAssessmentPage } from 'api/api';
import {
  checkSelectionAction,
  fetchAssessmentPageErrorAction,
  fetchAssessmentPageStartAction,
  fetchAssessmentPageSuccessAction,
} from 'actions/assessmentPage';
import { prepareUpdatePageAssessmentMessages } from 'actions/messages';
import { CheckMessage } from '../../types/check';
import { Review } from '../../types/review-category';
import { GET_ASSESSMENT_PAGE } from 'actions/assessmentPage/types';
import { RootReducer } from 'store/reducers';
import { getAlertByExternalId } from 'store/reducers/assessmentPage/selectors';

const getState = (state: RootReducer) => state;

const labelMessagesWithPageNumber = (
  pageNumber: number,
  messages: CheckMessage[]
): CheckMessage[] => {
  return messages.map((msg: CheckMessage) => {
    msg.pageNumber = pageNumber;
    return msg;
  });
};

export function* fetchAssessmentPage({ pageNumber, token }: AnyAction) {
  try {
    yield put(fetchAssessmentPageStartAction());

    abortPageController.abort();

    const { data: currentPage }: { data: AssessmentPagePayload } = yield call(
      getAssessmentPage,
      pageNumber,
      token
    );

    yield put(fetchAssessmentPageSuccessAction(currentPage));

    yield put(
      prepareUpdatePageAssessmentMessages(
        pageNumber,
        labelMessagesWithPageNumber(
          pageNumber,
          currentPage[Review.branding].messages
        ) as CheckMessage[]
      )
    );
    yield put(
      prepareUpdatePageAssessmentMessages(
        pageNumber,
        labelMessagesWithPageNumber(
          pageNumber,
          currentPage[Review.claims].messages
        ) as CheckMessage[]
      )
    );

    yield put(
      prepareUpdatePageAssessmentMessages(
        pageNumber,
        labelMessagesWithPageNumber(
          pageNumber,
          currentPage[Review.safety].messages
        ) as CheckMessage[]
      )
    );
    yield put(
      prepareUpdatePageAssessmentMessages(
        pageNumber,
        labelMessagesWithPageNumber(
          pageNumber,
          currentPage[Review.style].messages
        ) as CheckMessage[]
      )
    );
    yield put(
      prepareUpdatePageAssessmentMessages(
        pageNumber,
        labelMessagesWithPageNumber(
          pageNumber,
          currentPage.messages as CheckMessage[]
        ) as CheckMessage[]
      )
    );

    const state = yield select(getState);
    const externalAlert = yield getAlertByExternalId(state);

    if (externalAlert) {
      yield put(checkSelectionAction(externalAlert.id));
    }
  } catch (e) {
    console.error(e);
    if (e.response) {
      yield put(
        fetchAssessmentPageErrorAction(
          e.response?.data?.message,
          e.response?.status
        )
      );
    }
  }
}

export default function* watchFetchAssessmentPage() {
  yield takeEvery(GET_ASSESSMENT_PAGE, fetchAssessmentPage);
}
